import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createTopupAPI,
  fetchTopupListAPI,
  updateTopupAPI,
  updateTopupStatusAPI,
} from "../apis/subscription.api";
import { successToastify } from "../utils/toastify.util";

const baseFields = {
  id: "",
  name: "",
  description: "",
  items: "",
  teams: "",
  price: "",
};

const hasRequestSucceeded = (payload) =>
  payload?.success === true || Number(payload?.status) === 1;

const initialState = {
  isLoad: false,
  isBtnLoad: false,
  isRedirect: false,
  listData: [],
  totalCount: 0,
  fields: baseFields,
};

export const fetchTopups = createAsyncThunk("topup/fetchTopups", async (payload) => {
  try {
    const response = await fetchTopupListAPI(payload);
    return response;
  } catch (err) {
    const { data } = err.response;
    return data;
  }
});

export const createTopup = createAsyncThunk(
  "topup/createTopup",
  async (payload, thunkAPI) => {
    try {
      const response = await createTopupAPI(payload);
      if (response.success) {
        thunkAPI.dispatch(
          fetchTopups({
            limit: 10,
            offset: 0,
            searchText: "",
          }),
        );
      }
      return response;
    } catch (err) {
      const { data } = err.response;
      return data;
    }
  },
);

export const updateTopup = createAsyncThunk(
  "topup/updateTopup",
  async (payload, thunkAPI) => {
    try {
      const response = await updateTopupAPI(payload);
      if (response.success) {
        thunkAPI.dispatch(
          fetchTopups({
            limit: 10,
            offset: 0,
            searchText: "",
          }),
        );
      }
      return response;
    } catch (err) {
      const { data } = err.response;
      return data;
    }
  },
);

export const updateTopupStatus = createAsyncThunk(
  "topup/updateTopupStatus",
  async (payload, thunkAPI) => {
    try {
      const response = await updateTopupStatusAPI(payload);
      if (response.success) {
        if (payload.status === 1) {
          successToastify("Activated successfully");
        } else if (payload.status === 0) {
          successToastify("Deactivated successfully");
        } else {
          successToastify("Deleted successfully");
        }
        thunkAPI.dispatch(
          fetchTopups({
            limit: 10,
            offset: 0,
            searchText: "",
          }),
        );
      }
      return response;
    } catch (err) {
      const { data } = err.response;
      return data;
    }
  },
);

const topupSlice = createSlice({
  name: "topup",
  initialState,
  reducers: {
    setTopupFields: (state, action) => {
      state.fields = action.payload;
    },
    resetTopupFields: (state) => {
      state.fields = baseFields;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTopups.pending, (state) => {
      state.isLoad = true;
      state.listData = [];
    });
    builder.addCase(fetchTopups.fulfilled, (state, action) => {
      state.isLoad = false;
      state.isRedirect = false;
      state.listData = action.payload?.result || action.payload?.response || [];
      state.totalCount = Number(
        action.payload?.totalCount ??
          action.payload?.count ??
          action.payload?.total ??
          action.payload?.totalRecords ??
          state.listData.length,
      );
    });

    builder.addCase(createTopup.pending, (state) => {
      state.isBtnLoad = true;
      state.isRedirect = false;
    });
    builder.addCase(createTopup.fulfilled, (state, action) => {
      state.isBtnLoad = false;
      state.isRedirect = hasRequestSucceeded(action.payload);
    });
    builder.addCase(createTopup.rejected, (state) => {
      state.isBtnLoad = false;
      state.isRedirect = false;
    });

    builder.addCase(updateTopup.pending, (state) => {
      state.isBtnLoad = true;
      state.isRedirect = false;
    });
    builder.addCase(updateTopup.fulfilled, (state, action) => {
      state.isBtnLoad = false;
      state.isRedirect = hasRequestSucceeded(action.payload);
    });
    builder.addCase(updateTopup.rejected, (state) => {
      state.isBtnLoad = false;
      state.isRedirect = false;
    });
  },
});

export const { setTopupFields, resetTopupFields } = topupSlice.actions;
export default topupSlice.reducer;
